// extracted by mini-css-extract-plugin
export default {"togglebtn_color":"style_togglebtn_color__RDraS"};